const IS_PROD = process.env.NODE_ENV === 'production'
const CURRENT_VERSION = process.env.REACT_APP_VERSION || 'dev'

let isReloading = false
async function reloadOnce() {
  if (isReloading) return
  isReloading = true
  await clearAppData()
  window.location.reload()
}

async function clearAppData() {
  try {
    localStorage.clear()
    sessionStorage.clear()
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map(k => caches.delete(k)))
    }
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map(r => r.unregister()))
    }
  } catch (_) {}
}

export async function ensureFreshAssets() {
  const prev = localStorage.getItem('app_version')

  // DEV: no fetch, no reloads
  if (!IS_PROD) {
    if (prev !== CURRENT_VERSION)
      localStorage.setItem('app_version', CURRENT_VERSION)
    return
  }

  // PROD: fetch and compare
  try {
    const base = process.env.PUBLIC_URL || ''
    const res = await fetch(`${base}/version.json?ts=${Date.now()}`, {
      cache: 'no-store',
    })
    const { version: serverVersion } = await res.json()
    if (!serverVersion) return

    // first visit after deploy (bundle vs server)
    if (CURRENT_VERSION && serverVersion !== CURRENT_VERSION) {
      if (prev !== serverVersion)
        localStorage.setItem('app_version', serverVersion)
      await reloadOnce()
      return
    }

    // stored vs server changed (open tab discovers a deploy)
    if (prev && prev !== serverVersion) {
      await reloadOnce()
      return
    }

    // update baseline
    if (prev !== serverVersion)
      localStorage.setItem('app_version', serverVersion)
    return
  } catch (_) {
    // prod fallback
    if (prev && prev !== CURRENT_VERSION) {
      await reloadOnce()
      return
    }
    if (prev !== CURRENT_VERSION)
      localStorage.setItem('app_version', CURRENT_VERSION)
  }
}

// Watcher: no-op in dev
let watcherStarted = false
export function startVersionWatcher(intervalMs = 180000) {
  if (!IS_PROD) return () => {} // early exit in dev
  if (watcherStarted) return () => {}
  watcherStarted = true

  ensureFreshAssets()

  const tick = () => {
    if (!document.hidden) ensureFreshAssets()
  }
  const id = setInterval(tick, intervalMs)

  const onVis = () => {
    if (!document.hidden) ensureFreshAssets()
  }
  document.addEventListener('visibilitychange', onVis)

  const onStorage = e => {
    if (e.key === 'app_version' && e.oldValue !== e.newValue)
      ensureFreshAssets()
  }
  window.addEventListener('storage', onStorage)

  return () => {
    clearInterval(id)
    document.removeEventListener('visibilitychange', onVis)
    window.removeEventListener('storage', onStorage)
    watcherStarted = false
  }
}
